import { Directive, HostListener, ElementRef, HostBinding } from "@angular/core";
import { distinctUntilChanged, debounceTime } from "rxjs/operators";
import { Subject } from "rxjs/Subject";
import { InputManager } from "../game-engine/input-manager";
var CanvasController = (function () {
    function CanvasController(input_manager_, canvas_ref_) {
        this.input_manager_ = input_manager_;
        this.canvas_ref_ = canvas_ref_;
        this.resize_events = new Subject();
    }
    Object.defineProperty(CanvasController.prototype, "client_width", {
        get: function () {
            var width = this.canvas_ref_.nativeElement.clientWidth;
            return width > 1920 ? 1920 : width;
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(CanvasController.prototype, "client_height", {
        get: function () {
            var height = this.canvas_ref_.nativeElement.clientHeight;
            return height > 1080 ? 1080 : height;
        },
        enumerable: true,
        configurable: true
    });
    ;
    ;
    CanvasController.prototype.ngOnInit = function () {
        var _this = this;
        this.resize_sub_ = this.resize_events.pipe(distinctUntilChanged(function (x, y) { return x.width === y.width && x.height === y.height; }), debounceTime(100))
            .subscribe(function (changes) {
            _this.input_manager_.aspect = changes.width / changes.height;
            _this.canvas_width = changes.width;
            _this.canvas_height = changes.height;
        });
    };
    ;
    CanvasController.prototype.ngDoCheck = function () {
        this.resize_events.next({ width: this.client_width, height: this.client_height });
    };
    ;
    CanvasController.prototype.setFocus = function (event) {
        event.target.focus();
    };
    ;
    CanvasController.prototype.lostFocus = function (event) {
    };
    ;
    CanvasController.prototype.hideContextMenu = function () {
        return false;
    };
    ;
    CanvasController.prototype.onMouseWheel = function (event) {
        var scroll = (event.deltaY > 0) ? 1 : -1;
        this.input_manager_.setWheelDirection(scroll);
        return false;
    };
    ;
    CanvasController.prototype.setMouseUp = function (event) {
        event.stopPropagation();
        if (event.button == 0) {
            this.input_manager_.setMouseButton("left", false);
        }
        else if (event.button == 2) {
            this.input_manager_.setMouseButton("right", false);
        }
    };
    ;
    CanvasController.prototype.setMouseDown = function (event) {
        event.stopPropagation();
        if (event.button == 0) {
            this.input_manager_.setMouseButton("left", true);
        }
        else if (event.button == 2) {
            this.input_manager_.setMouseButton("right", true);
        }
    };
    ;
    CanvasController.prototype.onKeyDown = function (event) {
        var code = event.code || event.key;
        this.input_manager_.setKeyDown(code);
        return false;
    };
    ;
    CanvasController.prototype.onKeyUp = function (event) {
        var code = event.code || event.key;
        this.input_manager_.setKeyUp(code);
        return false;
    };
    ;
    CanvasController.prototype.setMouseMovement = function (event) {
        event.stopPropagation();
        var x = event.clientX / this.client_width;
        var y = 1 - (event.clientY / this.client_height);
        this.input_manager_.setMousePosition({ x: x, y: y });
        return false;
    };
    ;
    CanvasController.prototype.ngOnDestroy = function () {
        this.resize_sub_.unsubscribe();
    };
    ;
    CanvasController.decorators = [
        { type: Directive, args: [{
                    selector: "[canvas-controller]"
                },] },
    ];
    CanvasController.ctorParameters = function () { return [
        { type: InputManager, },
        { type: ElementRef, },
    ]; };
    CanvasController.propDecorators = {
        "canvas_width": [{ type: HostBinding, args: ["width",] },],
        "canvas_height": [{ type: HostBinding, args: ["height",] },],
        "setFocus": [{ type: HostListener, args: ["mouseenter", ["$event"],] },],
        "lostFocus": [{ type: HostListener, args: ["mouseleave", ["$event"],] },],
        "hideContextMenu": [{ type: HostListener, args: ["contextmenu",] },],
        "onMouseWheel": [{ type: HostListener, args: ["wheel", ["$event"],] },],
        "setMouseUp": [{ type: HostListener, args: ["mouseup", ["$event"],] },],
        "setMouseDown": [{ type: HostListener, args: ["mousedown", ["$event"],] },],
        "onKeyDown": [{ type: HostListener, args: ["keydown", ["$event"],] },],
        "onKeyUp": [{ type: HostListener, args: ["keyup", ["$event"],] },],
        "setMouseMovement": [{ type: HostListener, args: ["mousemove", ["$event"],] },],
    };
    return CanvasController;
}());
export { CanvasController };
//# sourceMappingURL=canvas-controller.directive.js.map